import React, { useState } from "react";
import Footer from "components/Footer";
import emailjs from "emailjs-com";

interface FormData {
  fullName: string;
  email: string;
  phone: string;
  address: string;
  message: string;
}

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [loading, setLoading] = useState(false); // add this at the top

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true); // disable button immediately

    const serviceID = "service_x6wktxd";
    const adminTemplateID = "template_asl7cr4";
    const userTemplateID = "template_bt1tkyi";
    const publicKey = "bu2T3VqvheXDN00w_";

    emailjs
      .send(
        serviceID,
        adminTemplateID,
        formData as unknown as Record<string, unknown>,
        publicKey
      )
      .then(() => {
        return emailjs.send(
          serviceID,
          userTemplateID,
          formData as unknown as Record<string, unknown>,
          publicKey
        );
      })
      .then(() => {
        setSubmitted(true);
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          address: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        alert("Something went wrong while sending your message.");
      })
      .finally(() => {
        setLoading(false); // re-enable after done
      });
  };


  const closeModal = () => setSubmitted(false);

  return (
    <div>
      {/* Modal */}
      {submitted && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000] bg-opacity-60">
          <div className="bg-[#fff] p-6 rounded-lg shadow-lg text-center w-[90%] max-w-md">
            <h2 className="text-xl font-semibold text-green-600 mb-4">
              Thank you! Your message has been submitted.
            </h2>
            <button
              onClick={closeModal}
              className="mt-4 bg-[#45336D] text-[#fff] px-6 py-2 rounded-md hover:bg-[#32255a] transition"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Main Section */}
      <section className="bg-[#45336D] py-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10 items-center">
          {/* Left Section */}
          <div className="md:w-1/2 text-[#fff]">
            <h2 className="text-4xl font-semibold mb-4 pe-12">Contact Us</h2>
            <p className="mb-6 pe-28">
              Not sure what you need? The team at Minterminds will be happy to
              listen to you and suggest event ideas you hadn’t considered.
            </p>
            <div className="space-y-4 text-sm">
              <p className="mb-5">Soriano Hway, Tanza, Cavite.</p>
              <p className="flex items-center mb-5">info@minterminds.com</p>
              <p className="flex items-center"> Support: +63 975 857 8476</p>
            </div>
          </div>

          {/* Right Section */}
          <div className="md:w-1/2 bg-[#fff] rounded-xl shadow-md p-8 w-full">
            <h3 className="text-xl font-semibold text-gray-900 mb-10">
              We’d love to hear from you! <br />
              Let’s get in touch
            </h3>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="flex flex-col md:flex-row gap-4">
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Full Name"
                  className="flex-1 border border-[#ccc] px-4 py-2 rounded"
                  required
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="flex-1 border border-[#ccc] px-4 py-2 rounded"
                  required
                />
              </div>

              <div className="flex flex-col md:flex-row gap-4">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => {
                    // Only allow digits in the input
                    const value = e.target.value.replace(/\D/g, ""); // remove non-digit characters
                    setFormData((prev) => ({
                      ...prev,
                      phone: value,
                    }));
                  }}
                  placeholder="Phone Number"
                  className="flex-1 border border-[#ccc] px-4 py-2 rounded"
                  pattern="\d{10}"
                  title="Enter a 10-digit phone number"
                  maxLength={10}
                  required
                />


                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Address"
                  className="w-full border border-[#ccc] px-4 py-2 rounded"
                />
              </div>

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows={4}
                className="w-full border border-[#ccc] px-4 py-2 rounded"
                required
              ></textarea>

              <button
                type="submit"
                disabled={loading}
                className={`bg-[#45336D] text-[#fff] px-6 py-2 rounded-md transition ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[#32255a]"
                  }`}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactUs;
